import React from "react"

import { BlogListSlider } from "../BlogListSlider"

import "./index.css"

const BlogInterest = ({ content, currentPostId, hasCustomClass=true, hasTitle=true, hasDate=false, title="Other Blogs of Interest", classNameVal="", displayLatestBlogPosts, colorValue, languageVal='English' }) => {
    console.log(languageVal)
    const titleLanguageVal = languageVal === 'French' 
        ? "Autres Blogs d'Intérêt" : languageVal === 'Spanish'
            ? 'Otros blogs de interés' : languageVal === 'Portuguese'
                ? 'Outros blogs de interesse' : languageVal === 'Arabic'
                    ? 'مدونات أخرى قد تهمك' : languageVal === 'German'
                        ? 'Andere interessante Blogs' : languageVal === 'Italian'
                            ? 'Altri Blog di Interesse' : languageVal === 'Japanese'
                                ? '興味深いその他のブログ' : languageVal === 'Indian - Hindi' 
                                    ? "अन्य रुचिकर ब्लॉग्स" : 'Other Blogs of Interest'
    return (
        <div className={`${hasCustomClass ? 'mt-30' : ''} ${classNameVal}`}>
            {hasTitle && <h3 className={`pt-16 mt-0 mb-0 ${colorValue === 'rgb(229, 62, 62)' ? 'text-white': 'text--dark'}`}>
                {title === 'Other Blogs of Interest' ? titleLanguageVal : title}
            </h3>}
            <BlogListSlider className={`pl-0 ${hasCustomClass && 'blog-other-interest'}`} content={displayLatestBlogPosts?null:content} currentPostId={currentPostId} hasDate={hasDate} showLast={displayLatestBlogPosts?30:0} colorValue={colorValue}/>
        </div>
    )
}

export default BlogInterest